import * as ng from 'angular';
import * as moment from 'moment';
import * as _ from 'underscore';

/**
 * Handles issuing non-async GET or POST requests that download files with
 * content disposition/attachment header.
 * The auth token is added as a request parameter automatically.
 */

ng.module('e360')
   .factory('fileDownload', fileDownloadFactory);

fileDownloadFactory.$inject = ['$q', '$window', '$cookies', '$timeout', 'session'];
export function fileDownloadFactory(
   $q:ng.IQService,
   $window:ng.IWindowService,
   $cookies,
   $timeout:ng.ITimeoutService,
   session
) {
   class FileDownload {
      private token:string;
      private deferred:ng.IDeferred<void>;

      constructor(private url:string, private args:{}) {
         this.token = session.getToken();
         this.deferred = $q.defer<void>();
      }

      private checkStatus() {
         if ($cookies.get('fileDownload')) {
            // server includes path parameter on set-cookie header
            $cookies.remove('fileDownload', { path: '/' });
            this.deferred.resolve();
         } else {
            $timeout(this.checkStatus.bind(this), 1000);
         }
      }

      private toQuery(obj:{}) {
         let params = _.map(obj, (v, k) => {
            if (v === null) return;

            let val:string;
            if (v instanceof Array) {
               val = v.join(',');
            } else if (v instanceof Date) {
               val = moment(v).format('YYYY-MM-DD');
            } else {
               val = v.toString();
            }

            return encodeURIComponent(k) + '=' + encodeURIComponent(val);
         });

         return _.filter(params, i => i !== null).join('&');
      }

      private objectFlatten(obj:{}, prefix:string = '') {
         let result = {};

         _.each(obj, (val, key) => {
            if (val === null) return;

            if (val instanceof Array) {
               result[prefix + key] = val;
            } else if (val instanceof Object) {
               result = _.extend(result, this.objectFlatten(val, prefix + key + '.'));
            } else {
               result[prefix + key] = val;
            }
         });

         return result;
      }

      /**
       * Retrieve only the download url
       */
      get_url() {
         let args = ng.extend({access_token: this.token}, this.args || {});
         return `${this.url}?${this.toQuery(args)}`;
      }

      get() {
         $window.location.href = this.get_url();

         this.checkStatus();
         return this.deferred.promise;
      }

      post() {
         let action = `${this.url}?access_token=${this.token}`;
         let form = ng.element('<form>', {method: 'POST', action: action});
         let formArgs = this.objectFlatten(this.args);

         _.each(formArgs, (val, key) => {
            if (val instanceof Array) {
               _.each(val, (aval) => {
                  form.append(ng.element('<input>', {type: 'hidden', name: key, value: aval}));
               });
            } else {
               form.append(ng.element('<input>', {type: 'hidden', name: key, value: val}));
            }
         });

         ng.element('body').append(form);
         form.submit();
         form.remove();

         this.checkStatus();
         return this.deferred.promise;
      }
   }

   return FileDownload;
}
